import React, { useEffect } from 'react';
import { LandingPage } from './pages/LandingPage';
import { useMetaPixel } from './hooks/useMetaPixel';
export function App() {
  useMetaPixel();
  useEffect(() => {
    document.title = 'Cero Panza';
  }, []);
  return <LandingPage data-id="element-0" />;
}